(() => {
  const runtimeKey = '__lgSingleProductRuntime';
  if (window[runtimeKey] === document) return;
  window[runtimeKey] = document;

  function initializeHeader() {
    if (document.querySelector('[data-lg-independent]')) return;
    const header = document.querySelector('#header-component');
    if (!header || header.dataset.lgHeaderInitialized === 'true' || !document.querySelector('[data-lg-section]')) return;
    header.dataset.lgHeaderInitialized = 'true';
    const updateHeader = () => {
      const hero = document.querySelector('.lg-campaign');
      const passedHero = hero && hero.getBoundingClientRect().bottom <= header.getBoundingClientRect().height;
      header.classList.toggle('lg-header-scrolled', Boolean(passedHero));
    };
    window.addEventListener('scroll', updateHeader, { passive: true });
    window.addEventListener('resize', updateHeader, { passive: true });
    updateHeader();
  }
  function initialize(root, excluded = null) {
    if (root.dataset.lgInitialized === 'true') return;
    root.dataset.lgInitialized = 'true';
    const scope = root.closest('[data-lg-product-page]') || root;
    const cleanups = initialize.cleanups || (initialize.cleanups = new WeakMap());
    cleanups.get(root)?.();
    const listeners = [];
    const on = (target, type, handler, options) => { if (!target) return; target.addEventListener(type, handler, options); listeners.push(() => target.removeEventListener(type, handler, options)); };
    cleanups.set(root, () => { listeners.forEach(remove => remove()); cleanups.delete(root); });
    const isExcluded = node => Boolean(excluded && (node === excluded || excluded.contains?.(node)));
    const all = selector => [...scope.querySelectorAll(selector)].filter(node => !isExcluded(node));
    const previewCapacity = root.querySelector('[data-lg-preview-capacity]');
    const variantSelect = root.querySelector('[data-lg-variant]');
    const variantsNode = root.querySelector('[data-lg-variants]');
    const quantityInput = root.querySelector('[data-lg-quantity-input]');
    const quantityButtons = all('[data-lg-quantity-step]');
    const capacityButtons = all('[data-lg-capacity-choice]');
    const nativeVariantButtons = all('[data-lg-variant-choice]');
    const benchmarkButtons = all('[data-lg-benchmark-tab]');
    const benchmarkPanels = all('[data-lg-benchmark]');
    const videoButtons = all('[data-lg-video-tab]');
    const videoPanels = all('[data-lg-video-panel]');
    const form = root.querySelector('form.lg-buy-form');
    const addButton = root.querySelector('[data-lg-add]');
    const express = root.querySelector('[data-lg-express]');
    const freeLabel = root.dataset.lgShippingFreeLabel || 'Free shipping';
    const toFreeLabel = root.dataset.lgShippingToFreeLabel || 'to free shipping';
    const shippingLabel = root.dataset.lgShippingLabel || 'shipping';
    const estimateLabel = root.dataset.lgShippingPreviewLabel || 'Preview estimate';
    let variants = [];
    if (variantsNode) {
      try { const parsed = JSON.parse(variantsNode.textContent); if (Array.isArray(parsed)) variants = parsed; } catch {}
    }
    const nativeCurrencyCode = String(root.dataset.lgCurrency || 'USD').trim().toUpperCase();
    let nativeCurrency;
    try { nativeCurrency = new Intl.NumberFormat(root.dataset.lgLocale || 'en', { style: 'currency', currency: nativeCurrencyCode, minimumFractionDigits: 0, maximumFractionDigits: 2 }); }
    catch { nativeCurrency = new Intl.NumberFormat('en', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 }); }
    const previewCurrency = new Intl.NumberFormat('en', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const withCents = formatter => { const options = formatter.resolvedOptions(); return new Intl.NumberFormat(options.locale, { style: 'currency', currency: options.currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
    const nativeCurrencyCents = withCents(nativeCurrency);
    const previewCurrencyCents = withCents(previewCurrency);
    const money = cents => (previewCapacity ? (cents % 100 ? previewCurrencyCents : previewCurrency) : (cents % 100 ? nativeCurrencyCents : nativeCurrency)).format(cents / 100);
    const shippingMoney = cents => (cents % 100 ? previewCurrencyCents : previewCurrency).format(cents / 100);
    const centsValue = (value, fallback = 0) => {
      if (value === undefined || value === null || String(value).trim() === '') return fallback;
      const number = Number(value);
      if (!Number.isFinite(number) || number < 0) return fallback;
      const rounded = Math.round(number);
      return Number.isSafeInteger(rounded) ? rounded : fallback;
    };
    const threshold = Math.max(1, centsValue(root.dataset.lgFreeThreshold, 10000));
    const shippingFee = centsValue(root.dataset.lgShippingFee, 3000);
    const previewOptions = previewCapacity ? [...previewCapacity.querySelectorAll('option')] : [];
    const selectedPreviewOption = () => previewOptions.find(option => option.selected) || previewOptions.find(option => option.value === previewCapacity?.value) || null;
    const selectedVariant = () => variantSelect ? variants.find(variant => String(variant.id) === String(variantSelect.value)) : null;
    const purchasable = variant => Boolean(!previewCapacity && root.dataset.lgReady === 'true' && variant && variant.available && Number.isFinite(Number(variant.price)) && Number(variant.price) > 0);
    function normalizedQuantity(value) {
      const rawMin = Number(quantityInput?.getAttribute('min'));
      const minimum = Number.isFinite(rawMin) ? Math.max(1, Math.ceil(rawMin)) : 1;
      const maxAttribute = quantityInput?.getAttribute('max');
      const rawMax = maxAttribute === null || maxAttribute === undefined || maxAttribute === '' ? Infinity : Number(maxAttribute);
      const maximum = Number.isFinite(rawMax) ? Math.max(minimum, Math.floor(rawMax)) : Infinity;
      const number = Number(value);
      return Math.max(minimum, Math.min(maximum, Number.isFinite(number) ? Math.floor(number) : minimum));
    }
    function showBenchmark(capacity) {
      if (!benchmarkPanels.some(panel => panel.dataset.lgBenchmark === capacity)) return;
      benchmarkPanels.forEach(panel => { panel.hidden = panel.dataset.lgBenchmark !== capacity; });
      benchmarkButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lgBenchmarkTab === capacity)));
    }
    function updateShipping(unitPrice, quantity) {
      const canEstimate = Boolean(previewCapacity) || nativeCurrencyCode === 'USD';
      all('[data-lg-order-estimate]').forEach(estimate => { estimate.hidden = !canEstimate; });
      if (!canEstimate) return;
      const tierQuantity = Math.min(quantity, 3);
      const liveTier = scope.querySelector(`.quantity-break[data-quantity="${tierQuantity}"][data-lg-volume-percent]`);
      const configuredPercent = Number(liveTier?.dataset.lgVolumePercent);
      const fallbackPercent = quantity >= 3 ? 10 : quantity >= 2 ? 5 : 0;
      const percent = root.dataset.lgVolumeEnabled === 'true' ? (liveTier && Number.isFinite(configuredPercent) ? configuredPercent : fallbackPercent) : 0;
      const calculated = (unitPrice - Math.floor(unitPrice * percent / 100)) * quantity;
      const subtotal = Number.isSafeInteger(calculated) ? calculated : 0;
      const free = unitPrice > 0 && subtotal >= threshold;
      const fee = free ? 0 : shippingFee;
      const remaining = Math.max(0, threshold - subtotal);
      all('[data-lg-order-subtotal]').forEach(output => { output.textContent = shippingMoney(subtotal); });
      all('[data-lg-shipping-cost]').forEach(output => { output.textContent = free ? freeLabel : shippingMoney(fee); });
      all('[data-lg-order-total]').forEach(output => { output.textContent = shippingMoney(subtotal + fee); });
      all('[data-lg-shipping-preview]').forEach(output => {
        output.textContent = free ? estimateLabel + ' · ' + freeLabel : estimateLabel + ' · ' + shippingMoney(fee) + ' ' + shippingLabel + ' · ' + shippingMoney(remaining) + ' ' + toFreeLabel;
      });
      all('[data-lg-shipping-progress]').forEach(progress => {
        progress.setAttribute('max', String(threshold));
        progress.setAttribute('value', String(Math.min(subtotal, threshold)));
        progress.setAttribute('aria-valuetext', free ? freeLabel : shippingMoney(remaining) + ' ' + toFreeLabel);
      });
    }
    function updatePurchase(syncBenchmark = false) {
      const option = selectedPreviewOption();
      const variant = selectedVariant();
      const unitPrice = previewCapacity ? centsValue(option?.dataset.lgPreviewPrice) : centsValue(variant?.price);
      const capacity = previewCapacity ? option?.value || '' : String(variant?.option1 || variant?.options?.[0] || variant?.title || '');
      const quantity = quantityInput ? normalizedQuantity(quantityInput.value) : 1;
      if (quantityInput) quantityInput.value = String(quantity);
      quantityButtons.forEach(button => {
        const step = Number(button.dataset.lgQuantityStep);
        button.disabled = !Number.isFinite(step) || normalizedQuantity(quantity + step) === quantity;
      });
      const price = root.querySelector(previewCapacity ? '[data-lg-price-preview]' : '[data-lg-price]');
      if (price) price.textContent = unitPrice > 0 ? money(unitPrice) : root.dataset.lgUnavailableLabel || 'Unavailable';
      if (capacity && capacity !== 'Default Title') {
        all('[data-lg-capacity-output]').forEach(output => { output.textContent = capacity; });
        capacityButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lgCapacityChoice === capacity)));
        if (syncBenchmark) showBenchmark(capacity);
      }
      updateShipping(unitPrice, quantity);
      const canPurchase = purchasable(variant);
      nativeVariantButtons.forEach(button => button.setAttribute('aria-pressed', String(Boolean(variant) && String(variant.id) === button.dataset.lgVariantChoice)));
      all('[data-lg-add]').forEach(addButton => {
        addButton.disabled = !canPurchase;
        addButton.setAttribute('aria-disabled', String(!canPurchase));
        const label = addButton.querySelector('[data-lg-button-label]') || addButton;
        label.textContent = canPurchase ? root.dataset.lgAddLabel || 'Add to cart' : root.dataset.lgUnavailableLabel || 'Unavailable';
      });
      if (express) express.hidden = !canPurchase;
      all('[data-lg-preview-add]').forEach(button => { button.disabled = true; button.setAttribute('aria-disabled', 'true'); });
    }
    capacityButtons.forEach(button => on(button, 'click', () => {
      if (!previewCapacity || button.disabled) return;
      const selected = previewOptions.find(option => option.value === button.dataset.lgCapacityChoice);
      if (!selected || selected.disabled) return;
      previewOptions.forEach(option => { option.selected = option === selected; });
      previewCapacity.dispatchEvent(new window.Event('change', { bubbles: true }));
    }));
    nativeVariantButtons.forEach(button => on(button, 'click', () => {
      if (!variantSelect || button.disabled) return;
      const id = button.dataset.lgVariantChoice;
      const variant = variants.find(candidate => String(candidate.id) === id);
      if (!variant || !variant.available || !Number.isFinite(Number(variant.price)) || Number(variant.price) <= 0) return;
      const options = [...variantSelect.querySelectorAll('option')];
      const selected = options.find(option => option.value === id);
      if (!selected || selected.disabled) return;
      options.forEach(option => { option.selected = option === selected; });
      variantSelect.dispatchEvent(new window.Event('change', { bubbles: true }));
    }));
    on(previewCapacity, 'change', () => updatePurchase(true));
    on(variantSelect, 'change', () => updatePurchase(true));
    if (quantityInput) {
      on(quantityInput, 'change', () => updatePurchase());
      on(quantityInput, 'input', () => {
        if (quantityInput.value !== '' && Number(quantityInput.value) === normalizedQuantity(quantityInput.value)) updatePurchase();
      });
      quantityButtons.forEach(button => on(button, 'click', event => {
        event.preventDefault();
        const step = Number(button.dataset.lgQuantityStep);
        if (!Number.isFinite(step)) return;
        quantityInput.value = String(normalizedQuantity(normalizedQuantity(quantityInput.value) + step));
        quantityInput.dispatchEvent(new window.Event('change', { bubbles: true }));
      }));
    }
    on(form, 'submit', event => {
      if (!purchasable(selectedVariant())) event.preventDefault();
      else if (quantityInput) quantityInput.value = String(normalizedQuantity(quantityInput.value));
    });
    const viewButtons = all('[data-lg-view]');
    viewButtons.forEach(button => on(button, 'click', () => {
      viewButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      all('[data-lg-photo]').forEach(photo => { photo.hidden = photo.dataset.lgPhoto !== button.dataset.lgView; });
    }));
    benchmarkButtons.forEach(button => on(button, 'click', () => showBenchmark(button.dataset.lgBenchmarkTab)));
    const proof = all('[data-lg-proof]')[0] || null;
    const fullFrameButtons = all('[data-lg-full-frame-toggle]');
    if (proof) {
      const updateFullFrame = fullFrame => {
        proof.dataset.lgFullFrame = String(fullFrame);
        fullFrameButtons.forEach(button => button.setAttribute('aria-pressed', String(fullFrame)));
      };
      updateFullFrame(proof.dataset.lgFullFrame === 'true');
      fullFrameButtons.forEach(button => on(button, 'click', () => updateFullFrame(proof.dataset.lgFullFrame !== 'true')));
    }
    let activeVideo = videoPanels.find(panel => !panel.hidden) || videoPanels[0];
    function showVideo(key, pausePrevious) {
      const next = videoPanels.find(panel => panel.dataset.lgVideoPanel === key);
      if (!next) return;
      if (pausePrevious && activeVideo && activeVideo !== next) {
        activeVideo.querySelectorAll('video').forEach(video => { if (typeof video.pause === 'function') video.pause(); });
        activeVideo.querySelectorAll('[data-lg-deferred-video]').forEach(player => player.dispatchEvent(new window.Event('lg:video-suspend')));
      }
      activeVideo = next;
      videoPanels.forEach(panel => { panel.hidden = panel !== next; });
      videoButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lgVideoTab === key)));
    }
    if (activeVideo) showVideo(activeVideo.dataset.lgVideoPanel, false);
    videoButtons.forEach(button => on(button, 'click', () => showVideo(button.dataset.lgVideoTab, true)));
    all('[data-lg-policy-link]').forEach(link => on(link, 'click', () => {
      const href = link.getAttribute('href') || '';
      if (!href.startsWith('#') || href.length < 2) return;
      let id;
      try { id = decodeURIComponent(href.slice(1)); } catch { return; }
      let details = document.getElementById(id)?.closest('details');
      while (details) { details.open = true; details = details.parentElement?.closest('details'); }
    }));
    updatePurchase(true);
  }
  function initializeAll(scope, { force = false, exclude = null } = {}) {
    initializeHeader();
    const page = scope.closest?.('[data-lg-product-page]') || (scope.matches?.('[data-lg-product-page]') ? scope : null);
    const pageRoot = page?.querySelector('[data-lg-section]') || (scope.matches?.('[data-lg-section]') ? scope : null);
    const roots = pageRoot ? [pageRoot] : [
      ...(scope.matches?.('[data-lg-section]') ? [scope] : []),
      ...scope.querySelectorAll('[data-lg-section]')
    ];
    for (const root of roots) {
      if (force) {
        initialize.cleanups?.get(root)?.();
        delete root.dataset.lgInitialized;
      }
      initialize(root, exclude);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  else initializeAll(document);
  document.addEventListener('shopify:section:unload', event => {
    const target = event.target;
    const page = target.closest?.('[data-lg-product-page]');
    const root = page?.querySelector('[data-lg-section]') || (target.matches?.('[data-lg-section]') ? target : target.querySelector?.('[data-lg-section]'));
    if (!root) return;
    initialize.cleanups?.get(root)?.();
    delete root.dataset.lgInitialized;
    if (target === root || !page) return;
    Promise.resolve().then(() => {
      if (root.isConnected !== false) initializeAll(page, { exclude: target });
    });
  });
  document.addEventListener('shopify:section:load', event => initializeAll(event.target, { force: true }));
})();

